import { useCurrentEvent } from '@hooks/events/use-current-event';

import type { EventRouteWrapperProps } from './event-route-wrapper.type';

export const EventRouteWrapper = ({
  publishedComponent: PublishedComponent,
  draftComponent: DraftComponent,
}: EventRouteWrapperProps) => {
  const { event, isLoading } = useCurrentEvent();

  if (isLoading || !event) return null;

  return event.isPublished ? <PublishedComponent /> : <DraftComponent />;
};
